<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-28 09:16:52
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-03-27 17:59:16
 * @FilePath: \vue-hepha-order\src\views\customer\CustomerList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <div class="queryPanel"  >
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <!-- 列表 -->
        <Table 
            :table="table"
            ref="customerTableRef"
            @expandRow="expandRow"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button v-permission="'setting.customer.addCustomer'" type="primary" size="mini" @click="handle('addCustomer')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('customer.addCustomer') }}
                </a-button>
            </template>

            <!-- 父表格自定义字段 -->
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'type'">
                    <a-tag :color="props.record.type == $t('customer.user')? 'blue' : props.record.type == $t('customer.dealer')? 'green' : props.record.type == $t('order.ECommerceVendor')? 'yellow' : 'orange'">{{ props.record.type }}</a-tag>
                </div>
            </template>

            <!--  自定义表头筛选 -->
            <template v-slot:searchFilter="{ props }">
                <div class="searchFilter">
                    <a-space direction="vertical">
                        <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" @press-enter="props.handleFilterConfirm" />
                        <div class="searchFilter-footer">
                            <a-button style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                            <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                        </div>
                    </a-space>
                </div>
            </template>

            <!-- 父表格操作 -->
            <template v-slot:tableOperate="{ props }">
                <a-tooltip :content="t('customer.addCustomerAddress')">
                    <a-button v-permission="'setting.customer.addCustomerAddress'" type="primary" size="mini" class="operateBtn" @click="handle('addCustomerAddress',props.record)">
                        <icon-plus size="14"/>
                    </a-button>
                </a-tooltip>
                <a-tooltip :content="t('customer.editCustomer')">
                    <a-button v-permission="'setting.customer.editCustomer'" type="primary" size="mini" class="operateBtn" @click="handle('edit',props.record)">
                        <icon-edit size="14"/>
                    </a-button>
                </a-tooltip> 
                <a-tooltip :content="t('customer.addLocation')">
                    <a-button v-permission="'setting.customer.addLocation'" v-if="props.record.type_val == 1" type="primary" size="mini" class="operateBtn" @click="handle('addLocation',props.record)">
                        <icon-location size="14"/>
                    </a-button>
                </a-tooltip>
                <a-tooltip :content="t('customer.addPickUpLocation')">
                    <a-button v-permission="'setting.customer.addLocation'" v-if="props.record.type_val == 1" type="primary" status="warning" size="mini" class="operateBtn" @click="handle('addPickUpLocation',props.record)">
                        <icon-location size="14"/>
                    </a-button>
                </a-tooltip>
                <a-button type="primary" v-if="props.record.show" size="mini" class="operateBtn" @click="handle('hide',props.record)">
                    <icon-eye size="14"/> 
                </a-button>
                <a-button type="primary" v-if="!props.record.show" size="mini" class="operateBtn" @click="handle('show',props.record)">
                    <icon-eye-invisible size="14"/>
                </a-button>
            </template>

            <!-- 子表格操作 -->
            <template v-slot:childTableOperate="{ props }">
                <a-tooltip :content="t('customer.editCustomerAddressTip')">
                    <a-button v-permission="'setting.customer.editCustomerAddress'" type="primary" size="mini" class="operateBtn" @click="handle('editAddress',props.record)">
                        <icon-edit size="14"/>
                    </a-button>
                </a-tooltip> 
                <a-tooltip :content="t('customer.editErpCodeTip')">
                    <a-button v-permission="'setting.customer.editErpCode'" v-if="rowData.type_val == 1" type="primary" size="mini" class="operateBtn" @click="handle('editErpCode',props.record)">
                        <icon-pen-fill size="14"/>
                    </a-button>
                </a-tooltip> 
                <a-tooltip :content="t('customer.deleteLineTip')">
                    <a-button v-permission="'setting.customer.deleteCustomerAddress'" type="primary" status="danger" size="mini" class="operateBtn" :disabled="(props.record.first_flag == 1 && props.record.address_type_val == 0) || (props.record.first_flag == 1 && props.record.address_type_val == 1)" @click="handle('deleteAddress',props.record)">
                        <icon-delete size="14"/>
                    </a-button>
                </a-tooltip> 
                <a-tooltip :content="t('customer.deleteSubERPCodeTip')">
                    <a-button v-permission="'setting.customer.deleteSubERPCode'" v-if="rowData.type_val == 1" type="primary" status="warning" size="mini" :disabled="props.record.erp_sub_code == '-'" class="operateBtn"  @click="handle('deleteSubERPCode',props.record)">
                        <icon-eraser size="14"/>
                    </a-button>
                </a-tooltip> 
                <a-button type="primary" v-if="props.record.lineIsShow" size="mini" class="operateBtn" @click="handle('lineHide',props.record)">
                    <icon-eye size="14"/> 
                </a-button>
                <a-button type="primary" v-if="!props.record.lineIsShow" size="mini" class="operateBtn" @click="handle('lineShow',props.record)">
                    <icon-eye-invisible size="14"/>
                </a-button>
            </template>
        </Table>

        <!-- 新增客户+客户地址 -->
        <a-modal
            v-model:visible="addFormVisible"
            width="60%"
            draggable
            :onBeforeOk="onAddCustomerBeforeOk"
        >
            <template #title>{{ $t('customer.addCustomer') }}</template>
            <!-- 客户基本信息 -->
            <a-divider orientation="center">{{ $t('customer.baseInfo') }}</a-divider>
            <Form
                class="editForm"
                :form="addBaseInfoForm"
                @handleSelectChange="handleAddCustomerSelectChange"
                @changeRadio="changeRadio">
            </Form>

            <!-- 客户默认地址信息 -->
            <a-divider orientation="center">{{ $t('customer.addressInfo') }}</a-divider>
            <Form
                class="editForm"
                :form="addAddressInfoForm"
                @handleInput="handleAddCustomerInputChange2"
                @handleInputClear="handleAddCustomerInputClear2"
                @handleSelectChange="handleAddCustomerSelectChange2">
            </Form>

            <a-checkbox v-model="checked" style="margin-left:25%" @change="changeCheck">{{ $t('customer.differentAddrTip') }}</a-checkbox>
        
            <!-- 发票地址 -->
            <a-divider v-if="checked" orientation="center" style="margin-top:40px">{{ $t('customer.addressInfo2') }}</a-divider>
            <Form
                v-if="checked"
                class="editForm"
                :form="addInvoiceAddressForm"
                @handleInput="handleAddCustomerInputChange3"
                @handleInputClear="handleAddCustomerInputClear3"
                @handleSelectChange="handleAddCustomerSelectChange3">
            </Form>
        </a-modal>

        <!-- 新增客户地址 -->
        <a-modal
            v-model:visible="addAddressFormVisible"
            width="60%"
            draggable
            :onBeforeOk="onAddCustomerAddressBeforeOk"
            @ok="handleAddAddressOK"
        >
            <template #title>{{ $t('customer.addCustomerAddress') }}</template>
            <Form
                class="editForm"
                :form="addAddressInfoForm"
                @handleInput="handleAddCustomerInputChange2"
                @handleInputClear="handleAddCustomerInputClear2"
                @handleSelectChange="handleAddCustomerSelectChange2">
            </Form>
        </a-modal>

        <!-- 编辑客户基本信息 -->
        <a-modal
            v-model:visible="editBaseFormVisible"
            width="60%"
            draggable
            :onBeforeOk="onBaseEditBeforeOk"
        >
            <template #title>{{ $t('customer.editCustomer') }}</template>
            <Form
                class="editForm"
                :form="editBaseInfoForm"
                @handleSelectChange="handleEditBaseInfoSelectChange">
            </Form>
        </a-modal>

        <!-- 编辑客户地址信息 -->
        <a-modal
            v-model:visible="editAddressFormVisible"
            width="60%"
            draggable
            :onBeforeOk="onAddressEditBeforeOk"
        >
            <template #title>{{ $t('customer.editAddressCustomer') }}</template>
            <Form
                class="editForm"
                :form="editAddressInfoForm"
                @handleInput="handleEditCustomerInputChange"
                @handleInputClear="handleEditCustomerInputClear"
                @handleSelectChange="handleEditAddressInfoSelectChange">
            </Form>
        </a-modal>

        <!-- 编辑经销商子级ERP Code -->
        <a-modal
            v-model:visible="editERPCodeFormVisible"
            width="30%"
            draggable
            :render-to-body="false"
            :onBeforeOk="onEditERPCodeBeforeOk"
        >
            <template #title>{{ $t('customer.editErpCodeTip') }}</template>
            <a-alert class="countBar" style="margin-bottom:10px">
                <span>{{ t('customer.subErpCodeTip2') }}</span>
            </a-alert>
            <a-input v-model="erp_sub_code" allow-clear :placeholder="t('customer.enterERPCode')" :style="{width:'320px'}"/>
        </a-modal>

        <!-- 新增/编辑 Location -->
        <a-modal
            v-model:visible="addLocationVisible"
            width="85%"
            draggable
            :footer="false"
        >
            <template #title>{{ $t('customer.addLocation') }}</template>
            <a-button 
                v-permission="'setting.customer.addCustomerAddress'"
                type="primary" 
                size="mini" 
                class="operateBtn" 
                @click="handle('addLocationLine')"
            >
                <icon-plus size="14" style="margin-right: 10px"/> {{ t('base.add') }}
            </a-button>
            <a-alert class="countBar" v-if="addLocationVisible">
                <span>{{$t('customer.source')}}: {{ rowData.source }}, </span>
                <span>{{$t('customer.customerErpCode')}}: {{ rowData.erp_code }}</span>
            </a-alert>
            <Table 
                class="locationTable"
                :table="locationTable"
            >
                <!-- 父表格自定义字段 -->
                <template v-slot:columns="{ props }">
                    <div v-if="props.column.key == 'location_name'">
                        <a-input 
                            :style="{width:'200px'}" 
                            v-model="props.record.location_name"
                            :disabled="props.record.disabled"
                        ></a-input>
                    </div>
                    <div v-if="props.column.key == 'shipping_address_id'">
                        <a-select 
                            :style="{width:'200px'}" 
                            v-model="props.record.shipping_address_id"
                            :options="shipOptions"
                            :disabled="props.record.disabled"
                            @change="(value)=>changeSelectLocationAddress(value, 'shipping_address_id', props.record)"
                        ></a-select>
                    </div>
                    <div v-if="props.column.key == 'invoice_address_id'">
                        <a-select 
                            :style="{width:'200px'}" 
                            v-model="props.record.invoice_address_id"
                            :options="invoiceOptions"
                            :disabled="props.record.disabled"
                            @change="(value)=>changeSelectLocationAddress(value, 'invoice_address_id', props.record)"
                        ></a-select>
                    </div>
                    <div v-if="props.column.key == 'base_address_id'">
                        <a-select 
                            :style="{width:'200px'}" 
                            v-model="props.record.base_address_id"
                            :options="baseOptions"
                            :disabled="props.record.disabled"
                            @change="(value)=>changeSelectLocationAddress(value, 'base_address_id', props.record)"
                        ></a-select>
                    </div>
                </template>
                <!-- 父表格操作 -->
                <template v-slot:tableOperate="{ props }">
                    <a-tooltip :content="t('base.edit')">
                        <a-button v-permission="'setting.customer.editLocation'" v-if="!props.record.isEdit" type="primary" size="mini" class="operateBtn" @click="handle('editLocation',props.record)">
                            <icon-edit size="14"/>
                        </a-button>
                    </a-tooltip>
                    <a-tooltip :content="t('base.save')">
                        <a-button v-permission="'setting.customer.saveLocation'" v-if="props.record.isEdit" type="primary" status="success" size="mini" class="operateBtn" @click="handle('saveLocation',props.record)">
                            <icon-file size="14"/>
                        </a-button>
                    </a-tooltip>
                </template>
            </Table>
        </a-modal>

        <!-- 添加C2C location地址 -->
        <a-modal
            v-model:visible="addPickUpLocationVisible"
            width="85%"
            draggable
            :footer="false"
        >
            <template #title>{{ $t('customer.addPickUpLocation') }}</template>
            <a-button 
                v-permission="'setting.customer.addCustomerAddress'"
                type="primary" 
                size="mini" 
                class="operateBtn" 
                @click="handle('addPickUpLocationLine')"
            >
                <icon-plus size="14" style="margin-right: 10px"/> {{ t('base.add') }}
            </a-button>
            <a-alert class="countBar" v-if="addPickUpLocationVisible">
                <span>{{$t('customer.source')}}: {{ rowData.source }}, </span>
                <span>{{$t('customer.customerErpCode')}}: {{ rowData.erp_code }}</span>
            </a-alert>
            <Table 
                class="pickUpLocationTable"
                :table="pickUpLocationTable"
            >
                <!-- 父表格自定义字段 -->
                <template v-slot:columns="{ props }">
                    <div v-if="props.column.key == 'pick_up_location_name'">
                        <a-input 
                            :style="{width:'200px'}" 
                            v-model="props.record.point_name"
                            :disabled="props.record.disabled"
                        ></a-input>
                    </div>
                    <div v-if="props.column.key == 'pick_up_location_address_id'">
                        <a-select 
                            :style="{width:'200px'}" 
                            v-model="props.record.address_id"
                            :options="pickUpOptions"
                            :disabled="props.record.disabled"
                            @change="(value)=>changeSelectPickUpLocationAddress(value, props.record)"
                        ></a-select>
                    </div>
                    <div v-if="props.column.key == 'pick_up_location_eabled_flag'">
                        <a-select 
                            :style="{width:'100px', color: props.record.enable_flag === 0 ? 'red' : ''}" 
                            v-model="props.record.enable_flag"
                            :options="pickUpEabledOptions"
                            :disabled="true"
                        ></a-select>
                    </div>
                    <div v-if="props.column.key == 'pick_up_location_country'">
                        <a-input 
                            :style="{width:'200px'}" 
                            v-model="props.record.country"
                            :disabled="true"
                        ></a-input>
                    </div>
                    <div v-if="props.column.key == 'pick_up_location_city'">
                        <a-input 
                            :style="{width:'200px'}" 
                            v-model="props.record.city"
                            :disabled="true"
                        ></a-input>
                    </div>
                    <div v-if="props.column.key == 'pick_up_location_address'">
                        <a-input 
                            :style="{width:'200px'}" 
                            v-model="props.record.address"
                            :disabled="true"
                        ></a-input>
                    </div>
                    <div v-if="props.column.key == 'pick_up_location_zip'">
                        <a-input 
                            :style="{width:'200px'}" 
                            v-model="props.record.zip"
                            :disabled="true"
                        ></a-input>
                    </div>
                </template>
                <!-- 父表格操作 -->
                <template v-slot:tableOperate="{ props }">
                    <a-tooltip :content="t('base.edit')">
                        <!--  v-permission="'setting.customer.editPickUpLocation'" -->
                        <a-button v-if="!props.record.isEdit" type="primary" size="mini" class="operateBtn" @click="handle('editPickUpLocation',props.record)">
                            <icon-edit size="14"/>
                        </a-button>
                    </a-tooltip>
                    <a-tooltip :content="t('base.invalid')">
                        <!--  v-permission="'setting.customer.editPickUpLocation'" -->
                        <a-button v-if="!props.record.isEdit" :disabled = "props.record.enable_flag == 0" type="primary" size="mini" class="operateBtn" status="warning" @click="handle('invalidPickUpLocation',props.record)">
                            <icon-minus-circle size="14"/>
                        </a-button>
                    </a-tooltip>
                    <a-tooltip :content="t('base.save')">
                        <!-- v-permission="'setting.customer.savePickUpLocation'" -->
                        <a-button v-if="props.record.isEdit" type="primary" status="success" size="mini" class="operateBtn" @click="handle('savePickUpLocation',props.record)">
                            <icon-file size="14"/>
                        </a-button>
                    </a-tooltip>
                </template>
            </Table>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import { useRouter, useRoute } from 'vue-router';
    import { CustomerApi } from '@/api/CustomerApi.js';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { 
        CustomerListQuery, 
        AddCustomerBaseInfoForm, 
        AddCustomerAddressInfoForm, 
        AddInvoiceAddressForm, 
        EditBaseInfoForm, 
        EditAddressInfoForm,
    } from './queryConfig/CustomerListQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek } from '@/utils/index.js';
    import { IconSearch } from '@arco-design/web-vue/es/icon';
    // 导入 Element Plus 图标
    // import { MapLocation } from '@element-plus/icons-vue';
    
    const localeStore = useLocale()
    const router = useRouter()
    const route = useRoute()

    const { t } = useI18n()

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const addFormVisible = ref(false) // 新增客户+地址
    const addAddressFormVisible = ref(false) // 新增客户地址
    const editBaseFormVisible = ref(false) // 编辑客户基本信息
    const editAddressFormVisible = ref(false) // 编辑客户地址信息
    const addLocationVisible = ref(false) // 新增Location
    const addPickUpLocationVisible = ref(false)
    const editERPCodeFormVisible = ref(false) // 编辑经销商ERP Code
    const showForm = ref(false)
    const queryForm = reactive(CustomerListQuery)
    const addBaseInfoForm = reactive(AddCustomerBaseInfoForm) // 新增客户
    const addAddressInfoForm = reactive(AddCustomerAddressInfoForm) // 新增客户地址
    const addInvoiceAddressForm = reactive(AddInvoiceAddressForm) // 新增客户发票地址
    const editBaseInfoForm = reactive(EditBaseInfoForm) // 编辑客户基本信息
    const editAddressInfoForm = reactive(EditAddressInfoForm) // 编辑客户地址信息
    const sourceList = reactive({})
    const rowData = ref(null)
    const rowHeadData = ref(null)
    const customerTableRef = ref(null)
    const checked = ref(false)
    const expandRowData = ref(null)
    const shipOptions = ref([])
    const invoiceOptions = ref([])
    const baseOptions = ref([])
    const pickUpOptions = ref([])
    const pickUpEabledOptions = ref([
        {
            label: 'YES',
            value: 1,
        },
        {
            label: 'NO',
            value: 0,
        }
    ])
    const erp_sub_code = ref('')
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: '客户名称',
                title: t('customer.contactNameNew'),
                dataIndex: 'name',
                key:'name',
                width:'260',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '来源',
                title: t('customer.source'),
                dataIndex: 'source',
                key:'source',
                width:'220',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: 'ERP客户编码',
                title: t('customer.customerErpCode'),
                dataIndex: 'customer_erp_code',
                key:'customer_erp_code',
                width:'100',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '客户类型',
                title: t('customer.customerType'),
                dataIndex: 'type',
                key:'type',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName: 'slot'
            },
            {
                // title: '客户邮箱',
                title: t('customer.customerEmail'),
                dataIndex: 'email',
                key:'email',
                width:'240',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '客户所在国家',
                title: t('customer.customerCountry'),
                dataIndex: 'country',
                key:'country',
                width:'110',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: 'location数量',
                title: t('customer.locationCount'),
                dataIndex: 'location_count',
                key:'location_count',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'215',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:480,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })

    const innerColumns = ref([
        {
            title: '#',
            dataIndex: 'No',
            key:'No',
            width:'60',
            fixed:'left',
            align:'left',
        },
        {
            title: t('customer.addressType'),
            dataIndex: 'address_type',
            key:'address_type',
            width:'160',
            align:'left',
        },
        {
            title: t('customer.contactName'),
            dataIndex: 'name',
            key:'name',
            width:'280',
            align:'left',
            filterable: {
                filter: (value, record) => record.name.includes(value),
                slotName: 'searchFilter',
                icon: () => h(IconSearch)
            }
        },
        {
            title: t('customer.contactName2'),
            dataIndex: 'name2',
            key:'name2',
            width:'150',
            align:'left',
        },
        {
            title: t('customer.dealerErpCode'),
            dataIndex: 'erp_sub_code',
            key:'erp_sub_code',
            width:'140',
            align:'left',
            filterable: {
                filter: (value, record) => record.erp_sub_code.includes(value),
                slotName: 'searchFilter',
                icon: () => h(IconSearch)
            }
        },
        {
            title: t('customer.customerEmail'),
            dataIndex: 'email',
            key:'email',
            width:'190',
            align:'left',
        }, 
        {
            title: t('order.orderConfirmMail'),
            dataIndex: 'order_confirm_mail',
            key:'email',
            width:'190',
            align:'left',
        },
        {
            title: t('customer.customerPhone'),
            dataIndex: 'phone',
            key:'phone',
            width:'180',
            align:'left',
        },
        {
            title: t('customer.zip'),
            dataIndex: 'zip',
            key:'zip',
            width:'120',
            align:'left',
        },
        {
            title: t('customer.customerCountry'),
            dataIndex: 'country',
            key:'country',
            width:'160',
            align:'left',
        },
        {
            title: t('customer.customerState'),
            dataIndex: 'state',
            key:'state',
            width:'160',
            align:'left',
        },
        {
            title: t('customer.customerCity'),
            dataIndex: 'city',
            key:'city',
            width:'160',
            align:'left',
        },
        {
            title: t('dealer.street'),
            dataIndex: 'street',
            key:'street',
            width:'160',
            align:'left',
        },
        {
            title: t('dealer.houseNumber'),
            dataIndex: 'house_number',
            key:'house_number',
            width:'160',
            align:'left',
        },
        {
            title: t('customer.customerAddr'),
            dataIndex: 'address',
            key:'address',
            width:'270',
            align:'left',
        },
        {
            title:t('order.operate'),
            dataIndex: 'Optional',
            key: 'Optional',
            slotName: 'optional',
            width: '220',
            align: 'center',
            fixed: 'right'
        }
    ])

    const innerConfigs = ref({
            scroll:{
                x:1000,
                y:500,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            pagination:false,
    })

    const locationTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'serial',
                key:'serial',
                width:'60',
                fixed:'left',
                align:'center',
            },
            {
                // title: 'location_name',
                title: t('customer.locationName'),
                dataIndex: 'location_name',
                key:'location_name',
                // width:'180',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot'
            },
            {
                // title: '发货地址',
                title: t('customer.shippingAddress'),
                dataIndex: 'shipping_address_id',
                key:'shipping_address_id',
                // width:'240',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot'
            },
            {
                // title: '发票地址',
                title: t('customer.invoiceAddress'),
                dataIndex: 'invoice_address_id',
                key:'invoice_address_id',
                // width:'240',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot'
            },
            {
                title:t('customer.contactForB2BShopLogin'),
                dataIndex: 'month',
                key:'month',
                // width:'340',
                align:'center',
                ellipsis:true,
                tooltip:true,
                children: [
                    {
                        // title: '基础地址',
                        title: t('customer.baseAddress'),
                        dataIndex: 'base_address_id',
                        key:'base_address_id',
                        // width:'240',
                        ellipsis:true,
                        tooltip:true,
                        align:'center',
                        slotName:'slot'
                    },
                    {
                        // title: '邮箱',
                        title: t('customer.customerEmail'),
                        dataIndex: 'customer_email',
                        key:'customer_email',
                        width:'200',
                        ellipsis:true,
                        tooltip:true,
                        align:'center',
                    },
                    {
                        // title: 'First name',
                        title: t('customer.firstName'),
                        dataIndex: 'first_name',
                        key:'first_name',
                        width:'150',
                        ellipsis:true,
                        tooltip:true,
                        align:'center',
                    },
                    {
                        // title: 'Last name',
                        title: t('customer.lastName'),
                        dataIndex: 'last_name',
                        key:'last_name',
                        width:'150',
                        ellipsis:true,
                        tooltip:true,
                        align:'center',
                    }
                ]
            },
            {
                // title: 'ID',
                title: t('customer.ID'),
                dataIndex: 'id',
                key:'id',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'90',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:480,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expand:false,
            expandable:'',
            pagination:false,
        },
    })

    const pickUpLocationTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex:'serial',
                key:'serial',
                width:'60',
                fixed:'left',
                align:'center',
            },
            {
                title: t('customer.pickUplocationName'),
                dataIndex: 'pick_up_location_name',
                key:'pick_up_location_name',
                width:'240',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot'
            },
            {
                title: t('customer.pickUpAddress'),
                dataIndex: 'pick_up_location_address_id',
                key:'pick_up_location_address_id',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot'
            },
            {
                title: t('customer.eabledFlag'),
                dataIndex: 'pick_up_location_eabled_flag',
                key:'pick_up_location_eabled_flag',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot'
            },
            {
                title: t('customer.country'),
                dataIndex: 'pick_up_location_country',
                key:'pick_up_location_country',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot'
            },
            {
                title: t('customer.city'),
                dataIndex: 'pick_up_location_city',
                key:'pick_up_location_city',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot'
            },
            {
                title: t('customer.baseAddress'),
                dataIndex: 'pick_up_location_address',
                key:'pick_up_location_address',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot'
            },
            {
                title: t('customer.zip'),
                dataIndex: 'pick_up_location_zip',
                key:'pick_up_location_zip',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot'
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'90',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:480,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expand:false,
            expandable:'',
            pagination:false,
        },
    })

    const typeOption = ref({
        0:t('customer.user'),
        1:t('customer.dealer'),
        3:t('order.notForSale'),
    })

    const init = ()=>{
        if(route && route.query.customer_entity_id){
            queryForm.formData.id = route.query.customer_entity_id
        }else{
            queryForm.formData.address_type = 0
        }
    }

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getCustomerHead()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                queryForm.formData.id = ''
                table.value.configs.pagination.current = 1
                getCustomerHead()
                break;
            case 'hide':
                row.show = !row.show
                row.name = desensitization(row.all_name)
                row.email = desensitization(row.all_email)
                break;
            case 'show':
                row.show = !row.show
                row.name = row.all_name
                row.email = row.all_email
                sensitive(row)
                break;
            case 'lineHide':
                row.lineIsShow = !row.lineIsShow
                row.name = desensitization(row.all_name)
                row.name2 = desensitization(row.all_name2)
                row.email = desensitization(row.all_email) 
                row.order_confirm_mail = desensitization(row.all_order_confirm_mail)
                row.phone = desensitization(row.all_phone)
                row.address = desensitization(row.all_address)
                break;
            case 'lineShow':
                row.lineIsShow = !row.lineIsShow
                row.name = row.all_name
                row.name2 = row.all_name2
                row.email = row.all_email
                row.order_confirm_mail = row.all_order_confirm_mail
                row.phone = row.all_phone
                row.address = row.all_address
                sensitive(row)
                break;
            case 'addCustomer': // 新增客户+地址
                addFormVisible.value = true
                checked.value = false
                addBaseInfoForm.formField.forEach(i=>{
                    addBaseInfoForm.formData[i.key] = ''
                    if(i.key == 'email_service_flag') i.show = false
                    if(i.key == 'email') i.disabled = true
                })
                addAddressInfoForm.formField.forEach(i=>{
                    addAddressInfoForm.formData[i.key] = ''
                    if(i.key == 'first_flag') i.show = false
                    if(i.key == 'email') i.disabled = false
                    if(i.key == 'house_number') i.disabled = true
                })
                addInvoiceAddressForm.formField.forEach(i=>{
                    addInvoiceAddressForm.formData[i.key] = ''
                    if(i.key == 'email') i.disabled = false
                    if(i.key == 'house_number') i.disabled = true
                })
                let item = addAddressInfoForm.formField.find(i=> i.key == 'address_type')
                item.disabled = true
                addAddressInfoForm.formData.address_type = 0
                addInvoiceAddressForm.formData.address_type = 1
                break;
            case 'addCustomerAddress': // 新增客户地址
                addAddressFormVisible.value = true
                addAddressInfoForm.formField.forEach(i=>{
                    addAddressInfoForm.formData[i.key] = ''
                    if(i.key == 'first_flag') i.show = true
                    if(i.key == 'house_number') i.disabled = true
                })
                let item2 = addAddressInfoForm.formField.find(i=> i.key == 'address_type')
                item2.disabled = false
                item2.options[2].disabled = row.type_val == 0
                item2.options[3].disabled = row.type_val == 0
                rowData.value = row
                break;
            case 'edit': // 编辑基本信息
                editBaseFormVisible.value = true
                editBaseInfoForm.formData.name = row.all_name
                editBaseInfoForm.formData.type = row.type_val
                editBaseInfoForm.formData.source = row.source_val
                editBaseInfoForm.formData.email = row.all_email
                editBaseInfoForm.formData.country = row.country
                editBaseInfoForm.formData.country_code = row.country_code
                editBaseInfoForm.formData.erp_code = row.erp_code
                rowData.value = row
                editBaseInfoForm.formField.find(i=> i.key == 'company_name').show = row.type_val == 1
                editBaseInfoForm.formData.company_name = row.type_val == 1? row.company_name : ''
                editBaseInfoForm.formData.email_service_flag = row.email_service_flag == 1? 'YES' : row.email_service_flag === 0? 'NO' : ''

                let email_service_flag_item = editBaseInfoForm.formField.find(i=> i.key == 'email_service_flag')
                email_service_flag_item.show = row.source_val === 10

                let email_item = editBaseInfoForm.formField.find(i=> i.key == 'email')
                email_item.disabled = row.email_service_flag === 0

                // 仅system,财务与权限修改公司名称
                let role_arr = userInfo.value.role.split(',')
                editBaseInfoForm.formField.find(i=> i.key == 'company_name').disabled = !(role_arr.includes('1') || role_arr.includes('4'))
                break;
            case 'editAddress': // 编辑地址信息
                editAddressFormVisible.value = true
                editAddressInfoForm.formData.name = row.all_name
                editAddressInfoForm.formData.name2 = row.all_name2 == '-'? '' : row.all_name2
                editAddressInfoForm.formData.email = row.all_email
                editAddressInfoForm.formData.order_confirm_mail = row.order_confirm_mail == '-'? row.all_email : row.all_order_confirm_mail
                editAddressInfoForm.formData.phone = row.all_phone == '-'? '' : row.all_phone
                editAddressInfoForm.formData.state = row.state == '-'? '' : row.state
                editAddressInfoForm.formData.city = row.city == '-'? '' : row.city
                editAddressInfoForm.formData.address_type = row.address_type_val
                editAddressInfoForm.formData.address = row.all_address == '-'? '' : row.all_address
                editAddressInfoForm.formData.zip = row.zip == '-'? '' : row.zip
                editAddressInfoForm.formData.country = row.country
                editAddressInfoForm.formData.country_code = row.country_code
                editAddressInfoForm.formData.street = row.street == '-'? '' : row.street
                editAddressInfoForm.formData.house_number = row.house_number == '-'? '' : row.house_number
                editAddressInfoForm.formData.first_flag = row.first_flag == 1
                rowData.value = row

                editAddressInfoForm.formField.forEach(i=>{
                    if(i.key == 'first_flag'){
                        i.show = true
                        i.disabled = row.first_flag == 1
                    } 
                    if(i.key == 'email'){
                        i.disabled = expandRowData.value.source_val === 10 && expandRowData.value.email_service_flag === 0
                    }
                })
                break;
            case 'editErpCode': // 编辑经销商子级ERP Code
                rowData.value = row
                editERPCodeFormVisible.value = true
                erp_sub_code.value = row.erp_sub_code == '-'? row.erp_code + '-'  : row.erp_sub_code
                break;
            case 'deleteAddress': // 删除地址
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('base.delConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        deleteAddress(row)
                    }
                });
                break;
            case 'deleteSubERPCode': // 删除子级ERP Code
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('base.delConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        deleteSubERPCode(row)
                    }
                });
                break;
            case 'addLocation':
                addLocationVisible.value = true
                rowData.value = row
                console.log(rowData.value,'riowData')
                getAddressSelectOption(row)
                getLocationList(row)
                break;
            case 'addLocationLine':
                locationTable.value.datas.push({
                    serial: locationTable.value.datas.length + 1,
                    location_name: '',
                    shipping_address_id: '',
                    invoice_address_id: '',
                    base_address_id: '',
                    customer_email: '',
                    first_name: '',
                    last_name: '',
                    disabled: false,
                    isEdit:true,
                    type:'add'
                })
                break;
            case 'editLocation':
                row.isEdit = true
                row.disabled = !row.disabled
                break;
            case 'saveLocation':
                editLocation(row)
                break;
            case 'addPickUpLocation':
                addPickUpLocationVisible.value = true
                rowData.value = row
                getPickUpLocationSelectOption(row)
                getPickUpLocationListData(row)
                break;
            case 'addPickUpLocationLine':
                pickUpLocationTable.value.datas.push({
                    serial: pickUpLocationTable.value.datas.length + 1,
                    point_name: '',
                    address_id: '',
                    enable_flag: 1,
                    country: '',
                    city: '',
                    address: '',
                    zip: '',
                    disabled: false,
                    isEdit:true,
                    type:'add'
                })
            case 'editPickUpLocation':
                row.isEdit = true
                row.disabled = !row.disabled
                break;
            case 'savePickUpLocation':
                editPickUpLocation(row)
                break;
            case 'invalidPickUpLocation':
                invalidPickUpLocationEdit(row)
                break;    
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        customerTableRef.value.expandedKeys = []
        getCustomerHead()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getCustomerHead()
    }

    // 列表查询-select
    const handleSelectChange = (val,opt,key)=>{
        console.log(val,opt,key,'kkkk')
        queryForm.formData[key] = val
        table.value.configs.pagination.current = 1
        getCustomerHead()
    }

    // 列表查询-input
    const handleInputClear = (item, val)=>{
        table.value.configs.pagination.current = 1
        getCustomerHead()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getCustomerHead()
    }

    // 关键信息加*号
    const desensitization = (string, mixLength = 3) =>{
        // mixLength 字符串少于一定值则脱敏全部，增加脱敏位数
        // if (isString(string) || isNumber(string)) {
            const str = String(string);
            if (str.length <= mixLength) {
                return '*'.repeat(mixLength);
            }
            const len = str.length;
            const firstStr = str.substr(0, str.length / mixLength);
            const lastStr = str.substr(-str.length / mixLength);
            const middleStr = str
            .substring(str.length / mixLength, len - Math.abs(-str.length / mixLength))
            .replace(/[\s\S]/gi, '*');
            return firstStr + middleStr + lastStr;
        // }
        // return '';
    }

    // 新增客户-select
    const handleAddCustomerSelectChange = async (val, opt, key)=>{
        console.log(val, opt, key,'val, opt, key')
        if(key == 'source'){
            const item = addBaseInfoForm.formField.find(i=> i.key == 'source')
            const optItem = item.options.find(i=> i.value == val)
            addBaseInfoForm.formData.erp_code = optItem.code
            addBaseInfoForm.formData.type = optItem.type
            addBaseInfoForm.formField.find(i=> i.key == 'company_name').show = addBaseInfoForm.formData.type == 1

            const email_service_flag_item = addBaseInfoForm.formField.find(i=> i.key == 'email_service_flag')
            email_service_flag_item.required = val == 10
            email_service_flag_item.show = val == 10
            addBaseInfoForm.formData.email_service_flag = ''

            const email_item = addBaseInfoForm.formField.find(i=> i.key == 'email')
            email_item.disabled = val == 10
            addBaseInfoForm.formData.email = ''

            const email_item2 = addAddressInfoForm.formField.find(i=> i.key == 'email')
            email_item2.disabled = val == 10
            addAddressInfoForm.formData.email = ''

            const email_item3 = addInvoiceAddressForm.formField.find(i=> i.key == 'email')
            email_item3.disabled = val == 10
            addInvoiceAddressForm.formData.email = ''

            if(val == 10){
                let address_info = JSON.parse(await getDefaultAddress())
                addAddressInfoForm.formData.email = address_info.email
                addAddressInfoForm.formData.phone = address_info.phone
                addAddressInfoForm.formData.zip = address_info.zip
                addAddressInfoForm.formData.country = address_info.country
                addAddressInfoForm.formData.country_code = address_info.country_code
                addAddressInfoForm.formData.state = address_info.state
                addAddressInfoForm.formData.city = address_info.city
                addAddressInfoForm.formData.address = address_info.address
            }else{
                addAddressInfoForm.formData.email = ''
                addAddressInfoForm.formData.phone = ''
                addAddressInfoForm.formData.zip = ''
                addAddressInfoForm.formData.country = ''
                addAddressInfoForm.formData.country_code = ''
                addAddressInfoForm.formData.state = ''
                addAddressInfoForm.formData.city = ''
                addAddressInfoForm.formData.address = ''
            }
            
        }
        if(key == 'country'){
           const item = addBaseInfoForm.formField.find(i=> i.key == 'country')
           const optItem = item.options.find(i=> i.value == val)
           addBaseInfoForm.formData.country_code = optItem.code
        }
    }

    const changeRadio = (key)=>{
        if(key == 'email_service_flag'){
            const email_item = addBaseInfoForm.formField.find(i=> i.key == 'email')
            email_item.disabled = addBaseInfoForm.formData.email_service_flag == 'NO'
            addBaseInfoForm.formData.email = addBaseInfoForm.formData.email_service_flag == 'NO'? 'service@hepha.com' : ''

            const email_item2 = addAddressInfoForm.formField.find(i=> i.key == 'email')
            email_item2.disabled = addBaseInfoForm.formData.email_service_flag == 'NO'
            addAddressInfoForm.formData.email = addBaseInfoForm.formData.email_service_flag == 'NO'? 'service@hepha.com' : ''
        
            const email_item3 = addInvoiceAddressForm.formField.find(i=> i.key == 'email')
            email_item3.disabled = addBaseInfoForm.formData.email_service_flag == 'NO'
            addInvoiceAddressForm.formData.email = addBaseInfoForm.formData.email_service_flag == 'NO'? 'service@hepha.com' : ''
        }
    }

    // 勾选复选框
    const changeCheck = ()=>{
        console.log(checked.value,'ck')
        if(checked.value){
            const email_item = addInvoiceAddressForm.formField.find(i=> i.key == 'email')
            email_item.disabled = addBaseInfoForm.formData.email_service_flag == 'NO'
            addInvoiceAddressForm.formData.email = addBaseInfoForm.formData.email_service_flag == 'NO'? 'service@hepha.com' : ''
        }else{
            const email_item = addInvoiceAddressForm.formField.find(i=> i.key == 'email')
            email_item.disabled = false
            addInvoiceAddressForm.formData.email = ''
        }
    }


    // 新增地址-select
    const handleAddCustomerSelectChange2 = (val, opt, key)=>{
        console.log(val, opt, key,'val, opt, key')
        if(key == 'country'){
           const item = addAddressInfoForm.formField.find(i=> i.key == 'country')
           const optItem = item.options.find(i=> i.value == val)
           addAddressInfoForm.formData.country_code = optItem.code
        }
    }

    // 新增发票地址-select
    const handleAddCustomerSelectChange3 = (val, opt, key)=>{
        console.log(val, opt, key,'val, opt, key')
        if(key == 'country'){
           const item = addInvoiceAddressForm.formField.find(i=> i.key == 'country')
           const optItem = item.options.find(i=> i.value == val)
           addInvoiceAddressForm.formData.country_code = optItem.code
        }
    }

    // 编辑客户-select
    const handleEditBaseInfoSelectChange = (val, opt, key)=>{
        console.log(val, opt, key,'val, opt, key')
        if(key == 'country'){
           const item = editBaseInfoForm.formField.find(i=> i.key == 'country')
           const optItem = item.options.find(i=> i.value == val)
           editBaseInfoForm.formData.country_code = optItem.code
        }
    }

    // 编辑地址-select
    const handleEditAddressInfoSelectChange = (val, opt, key)=>{
        console.log(val, opt, key,'val, opt, key')
        if(key == 'country'){
           const item = editAddressInfoForm.formField.find(i=> i.key == 'country')
           const optItem = item.options.find(i=> i.value == val)
           editAddressInfoForm.formData.country_code = optItem.code
        }
    }

    const expandRow = (rowKey,record)=>{
        console.log(rowKey,record,'rowKey,record')
        rowData.value = record
        rowHeadData.value = record
        expandRowData.value = JSON.parse(JSON.stringify(record))
        customerTableRef.value.expandedKeys = customerTableRef.value.expandedKeys.length !== 0? [record.id] : []
        getCustomerLine(record)
    }

    // 获取客户列表-头
    const getCustomerHead = async ()=>{
        let param = {
            ...queryForm.formData,
            email:queryForm.formData.email.trim(),
            location_flag:1,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await CustomerApi.getInstance().getCustomerList(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                table.value.datas.push({
                    ...item,
                    No: index + 1,
                    name: !item.name? '-' : desensitization(item.name),
                    // name2: !item.name2? '-' : desensitization(item.name2),
                    email: !item.email? '-' : desensitization(item.email),
                    all_name: !item.name? '-' : item.name,
                    // all_name2: !item.name2? '-' : item.name2,
                    all_email: !item.email? '-' : item.email,
                    type_val:item.type,
                    location_count: item.type == 0? '-' : item.location_count == undefined? 0 : item.location_count,
                    type: typeOption.value[item.type],
                    source_val: item.source,
                    source: sourceList[item.source],
                    customer_erp_code: item.erp_code,
                    create_date: item.create_date == undefined? '-' : item.create_date,
                    update_date: item.update_date == undefined? '-' : item.update_date,
                    show:false,
                    child:{
                        innerDatas:[],
                        innerColumns:innerColumns.value,
                        innerConfigs:innerConfigs.value
                    }
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.pagination.current = res.data.current
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取客户列表-行
    const getCustomerLine = async (row)=>{
        let itemRow = table.value.datas.find(i=> i.id == row.id)
        itemRow.child.innerConfigs.loading = true
        let res = await CustomerApi.getInstance().getAddressList({customer_entity_id:row.id})
        if(res.code == 0){
            itemRow.child.innerDatas = []
            res.data.length > 0 && res.data.forEach((item,index)=>{
                itemRow.child.innerDatas.push({
                    ...item,
                    No: index + 1,
                    state: !item.state? '-' : item.state,
                    city: !item.city? '-' : item.city,
                    street: !item.street? '-' : item.street,
                    house_number: !item.house_number? '-' : item.house_number,
                    zip: !item.zip? '-' : item.zip,
                    address_type_val: item.address_type == undefined? '' : item.address_type,
                    address_type: item.address_type == undefined? '-' : item.address_type == 0? item.first_flag == 1? `* ${t('customer.defaultAddress')}` : `${t('customer.defaultAddress')}` : item.address_type == 1? item.first_flag == 1? `* ${t('customer.invoiceAddress')}` : `${t('customer.invoiceAddress')}` : item.address_type == 2? t('customer.companyAddress') : t('customer.storeAddress'),
                    name: !item.name? '-' : desensitization(item.name),
                    name2: !item.name2? '-' : desensitization(item.name2),
                    email: !item.email? '-' : desensitization(item.email),
                    order_confirm_mail: !item.order_confirm_mail? '-' : desensitization(item.order_confirm_mail),
                    phone: !item.phone? '-' : desensitization(item.phone),
                    address: !item.address? '-' : desensitization(item.address),
                    all_name: !item.name? '-' : item.name,
                    all_name2: !item.name2? '-' : item.name2,
                    all_email: !item.email? '-' : item.email,
                    all_order_confirm_mail: !item.order_confirm_mail? '-' : item.order_confirm_mail,
                    all_phone:  !item.phone? '-' : item.phone,
                    all_address: !item.address? '-' : item.address,
                    customer_erp_code: item.erp_code,
                    lineIsShow:false,
                    customer_entity_id: row.id,
                    type_val: row.type_val,
                    source_val: row.source_val,
                    erp_code: row.erp_code,
                    erp_sub_code: !item.erp_sub_code? '-' : item.erp_sub_code
                })
            })

            itemRow.child.innerDatas.forEach(i=>{
                i.disabled = itemRow.child.innerDatas.length == 1
            })
            
            itemRow.child.innerConfigs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 新增location，获取客户地址下拉数据
    const getAddressSelectOption = async (row)=>{
        let res = await CustomerApi.getInstance().getAddressList({customer_entity_id:row.id})
        if(res.code == 0){
            shipOptions.value = []
            invoiceOptions.value = []
            baseOptions.value = []

            res.data && res.data.forEach(i=>{
                shipOptions.value.push({
                    label: `${i.name2},${i.address}`,
                    value: i.id,
                    item: i,
                })
                invoiceOptions.value.push({
                    label: `${i.name2},${i.address}`,
                    value: i.id,
                    item: i,
                })
                baseOptions.value.push({
                    label: `${i.name2},${i.address}`,
                    value: i.id,
                    item: i,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    const getPickUpLocationSelectOption = async (row)=>{
        let res = await CustomerApi.getInstance().getAddressList({customer_entity_id:row.id})
        if(res.code == 0){
            pickUpOptions.value = []

            res.data && res.data.forEach(i=>{
                pickUpOptions.value.push({
                    label: `${i.name2},${i.address}`,
                    value: i.id,
                    item: i,
                    // data: {
                    //     id: i.id,
                    //     name: i.name,
                    //     name2: i.name2,
                    //     address: i.address,
                    //     zip: i.zip,
                    //     country: i.country,
                    //     city: i.city,
                    //     phone: i.phone,
                    //     email: i.email,
                    // }
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    const handleAddCustomerInputChange2 = (item, val)=>{
        console.log(item.key, val, 'iipppp')
        if(item.key == 'email'){
            addAddressInfoForm.formData.order_confirm_mail = val
        }
        if(item.key == 'street'){
            addAddressInfoForm.formData.address = !addAddressInfoForm.formData.house_number? val : `${val} ${addAddressInfoForm.formData.house_number}`
            let house_number_item = addAddressInfoForm.formField.find(i=> i.key == 'house_number')
            house_number_item.disabled = false
        }
        if(item.key == 'house_number'){
            addAddressInfoForm.formData.address = `${addAddressInfoForm.formData.street} ${val}`
        }
    }

    const handleAddCustomerInputChange3 = (item, val)=>{
        if(item.key == 'street'){
            addInvoiceAddressForm.formData.address = !addInvoiceAddressForm.formData.house_number? val : `${val} ${addInvoiceAddressForm.formData.house_number}`
            let house_number_item = addInvoiceAddressForm.formField.find(i=> i.key == 'house_number')
            house_number_item.disabled = false
        }
        if(item.key == 'house_number'){
            addInvoiceAddressForm.formData.address = `${addInvoiceAddressForm.formData.street} ${val}`
        }
    }

    const handleEditCustomerInputChange = (item, val)=>{
        if(item.key == 'street'){
            editAddressInfoForm.formData.address = !editAddressInfoForm.formData.house_number? val : `${val} ${editAddressInfoForm.formData.house_number}`
            let house_number_item = editAddressInfoForm.formField.find(i=> i.key == 'house_number')
            house_number_item.disabled = false
        }
        if(item.key == 'house_number'){
            editAddressInfoForm.formData.address = `${editAddressInfoForm.formData.street} ${val}`
        }
    }

    const handleAddCustomerInputClear2 = (val, item)=>{
        if(item.key == 'street'){
            addAddressInfoForm.formData.address = addAddressInfoForm.formData.house_number
            let house_number_item = addAddressInfoForm.formField.find(i=> i.key == 'house_number')
            house_number_item.disabled = true
        }
        if(item.key == 'house_number'){
            addAddressInfoForm.formData.address = addAddressInfoForm.formData.street
        }
    }

    const handleAddCustomerInputClear3 = (val, item)=>{
        if(item.key == 'street'){
            addInvoiceAddressForm.formData.address = addInvoiceAddressForm.formData.house_number
            let house_number_item = addInvoiceAddressForm.formField.find(i=> i.key == 'house_number')
            house_number_item.disabled = true
        }
        if(item.key == 'house_number'){
            addInvoiceAddressForm.formData.address = addInvoiceAddressForm.formData.street
        }
    }

    const handleEditCustomerInputClear = (val, item)=>{
        if(item.key == 'street'){
            editAddressInfoForm.formData.address = editAddressInfoForm.formData.house_number
            let house_number_item = editAddressInfoForm.formField.find(i=> i.key == 'house_number')
            house_number_item.disabled = true
        }
        if(item.key == 'house_number'){
            editAddressInfoForm.formData.address = editAddressInfoForm.formData.street
        }
    }

    // 新增客户
    const onAddCustomerBeforeOk = async ()=>{
        let email_pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,}$/
        let base_email_bool = email_pattern.test(addBaseInfoForm.formData.email)
        let address_email_bool = email_pattern.test(addAddressInfoForm.formData.email)
        let invoice_address_email_bool = email_pattern.test(addInvoiceAddressForm.formData.email)

        if(!addBaseInfoForm.formData.name){ // 客户基本信息
            Message.error(t('customer.customerName') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addBaseInfoForm.formData.source){
            Message.error(t('order.orderSource') + ' ' + t('base.noEmpty'))
            return false
        }else if(addBaseInfoForm.formData.type === ''){
            Message.error(t('customer.customerType') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addBaseInfoForm.formData.email){ 
            Message.error(t('customer.customerEmail') + ' ' + t('base.noEmpty'))
            return false
        }else if(!!addBaseInfoForm.formData.email && !base_email_bool){ 
            Message.error(t('customer.customerEmailFormatError'))
            return false
        }else if(!addBaseInfoForm.formData.country){
            Message.error(t('customer.customerCountry') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.name){ // 客户默认地址信息
            Message.error(t('customer.customerName') + ' ' + t('base.noEmpty'))
            return false
        }else if(addAddressInfoForm.formData.email === ''){
            Message.error(t('customer.customerEmail') + ' ' + t('base.noEmpty'))
            return false
        }else if(!!addAddressInfoForm.formData.email && !address_email_bool){ 
            Message.error(t('customer.customerEmailFormatError'))
            return false
        }else if(addAddressInfoForm.formData.phone === ''){
            Message.error(t('customer.customerPhone') + ' ' + t('base.noEmpty'))
            return false
        }else if(addAddressInfoForm.formData.zip === ''){
            Message.error(t('customer.zip') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.country){
            Message.error(t('customer.customerCountry') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.city){
            Message.error(t('customer.customerCity') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.street){
            Message.error(t('dealer.street') + ' ' + t('base.noEmpty'))
            return false
        }else if(addAddressInfoForm.formData.address === ''){
            Message.error(t('customer.customerAddr') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.house_number){
            Message.error(t('dealer.houseNumber') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !addInvoiceAddressForm.formData.name){  // 客户发票地址信息
            Message.error(t('customer.customerName') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && addInvoiceAddressForm.formData.email === ''){
            Message.error(t('customer.customerEmail') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !!addInvoiceAddressForm.formData.email && !invoice_address_email_bool){ 
            Message.error(t('customer.customerEmailFormatError'))
            return false
        }else if(checked.value && addInvoiceAddressForm.formData.phone === ''){
            Message.error(t('customer.customerPhone') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && addInvoiceAddressForm.formData.zip === ''){
            Message.error(t('customer.zip') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !addInvoiceAddressForm.formData.country){
            Message.error(t('customer.customerCountry') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !addInvoiceAddressForm.formData.city){
            Message.error(t('customer.customerCity') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !addInvoiceAddressForm.formData.street){
            Message.error(t('dealer.street') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && addInvoiceAddressForm.formData.address === ''){
            Message.error(t('customer.customerAddr') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !addInvoiceAddressForm.formData.house_number){
            Message.error(t('dealer.houseNumber') + ' ' + t('base.noEmpty'))
            return false
        }


        let invoiceAddrForm = checked.value? addInvoiceAddressForm.formData : addAddressInfoForm.formData
        let param = {
           ...addBaseInfoForm.formData,
           email_service_flag: addBaseInfoForm.formData.email_service_flag == 'YES'? 1 : addBaseInfoForm.formData.email_service_flag == 'NO'? 0 : '',
           order_address_vos:[{
                ...addAddressInfoForm.formData,
                first_flag:1,
                type: addBaseInfoForm.formData.type,
                source: addBaseInfoForm.formData.source,
                erp_code: addBaseInfoForm.formData.erp_code,
           },{
                ...invoiceAddrForm,
                address_type:1,
                first_flag:1,
                type: addBaseInfoForm.formData.type,
                source: addBaseInfoForm.formData.source,
                erp_code: addBaseInfoForm.formData.erp_code,
           }]
        }
        let res = await CustomerApi.getInstance().addCustomer(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            getCustomerHead()
            customerTableRef.value.expandedKeys = []
            return true
        }else{
            Message.error(res.msg)
            return false
        }
    }

    // 新增客户地址信息
    const onAddCustomerAddressBeforeOk = async ()=>{
        let email_pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,}$/
        let email_bool = email_pattern.test(addAddressInfoForm.formData.email)
        let order_confirm_email_bool = email_pattern.test(addAddressInfoForm.formData.order_confirm_mail)

        if(addAddressInfoForm.formData.address_type === ''){
            Message.error(t('customer.addressType') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.name){
            Message.error(t('customer.customerName') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.email){
            Message.error(t('customer.customerEmail') + ' ' + t('base.noEmpty'))
            return false
        }else if(!email_bool && !!addAddressInfoForm.formData.email){
            Message.error(t('customer.customerEmailFormatError'))
            return false
        }else if(!addAddressInfoForm.formData.order_confirm_mail){
            Message.error(t('order.orderConfirmMail') + ' ' + t('base.noEmpty'))
            return false
        }else if(!order_confirm_email_bool && !!addAddressInfoForm.formData.order_confirm_mail){
            Message.error(t('customer.orderConfirmMailFormatError'))
            return false
        }else if(!addAddressInfoForm.formData.phone){
            Message.error(t('customer.customerPhone') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.zip){
            Message.error(t('customer.zip') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.country){
            Message.error(t('customer.customerCountry') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.city){
            Message.error(t('customer.customerCity') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.street){
            Message.error(t('dealer.street') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.address){
            Message.error(t('customer.customerAddr') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.house_number){
            Message.error(t('dealer.houseNumber') + ' ' + t('base.noEmpty'))
            return false
        }

        return true
    }

    const handleAddAddressOK = async()=>{
        let param = {
           ...addAddressInfoForm.formData,
           type: rowData.value.type_val,
           source: rowData.value.source_val,
           erp_code: rowData.value.erp_code,
           customer_entity_id: rowData.value.id,
           first_flag: addAddressInfoForm.formData.first_flag? 1 : 0,
        }
        table.value.configs.loading = true

        console.log(param,'param')
        let res = await CustomerApi.getInstance().addAddress(param)
        if(res.code == 0){
            Message.success(t('base.editSuccess'))
            if(route && route.query.fromPage){
                table.value.configs.loading = false
                router.replace(`/${route.query.fromPage}`)
            }else{
                // getCustomerHead()
                // customerTableRef.value.expandedKeys = []
                expandRow(rowHeadData.value.id, rowHeadData.value)
                table.value.configs.loading = false
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 编辑客户基本信息
    const onBaseEditBeforeOk = async ()=>{
        if(!editBaseInfoForm.formData.name){
            Message.error(t('customer.customerName') + ' ' + t('base.noEmpty'))
            return false
        }else if(!editBaseInfoForm.formData.email){
            Message.error(t('customer.customerEmail') + ' ' + t('base.noEmpty'))
            return false
        }

        let param = {
           ...editBaseInfoForm.formData,
           email_service_flag: editBaseInfoForm.formData.email_service_flag == 'YES'? 1 : editBaseInfoForm.formData.email_service_flag == 'NO'? 0 : '',
           id: rowData.value.id
        }
        table.value.configs.loading = true
        let res = await CustomerApi.getInstance().editCustomer(param,rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.editSuccess'))
            if(route && route.query.fromPage){
                table.value.configs.loading = false
                router.replace(`/${route.query.fromPage}`)
            }else{
                getCustomerHead()
                customerTableRef.value.expandedKeys = []
            }
            return true
        }else{
            Message.error(res.msg)
        }
    }

    // 编辑客户地址信息
    const onAddressEditBeforeOk = async ()=>{
        let email_pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,}$/
        let email_bool = email_pattern.test(editAddressInfoForm.formData.email)
        let order_confirm_email_bool = email_pattern.test(editAddressInfoForm.formData.order_confirm_mail)

        if(!editAddressInfoForm.formData.name){
            Message.error(t('customer.customerName') + ' ' + t('base.noEmpty'))
            return false
        }else if(!editAddressInfoForm.formData.email){
            Message.error(t('customer.customerEmail') + ' ' + t('base.noEmpty'))
            return false
        }else if(!email_bool && !!editAddressInfoForm.formData.email){
            Message.error(t('customer.customerEmailFormatError'))
            return false
        }else if(!editAddressInfoForm.formData.order_confirm_mail){
            Message.error(t('order.orderConfirmMail') + ' ' + t('base.noEmpty'))
            return false
        }else if(!order_confirm_email_bool && !!editAddressInfoForm.formData.order_confirm_mail){
            Message.error(t('customer.orderConfirmMailFormatError'))
            return false
        }else if(!editAddressInfoForm.formData.phone){
            Message.error(t('customer.customerPhone') + ' ' + t('base.noEmpty'))
            return false
        }else if(!editAddressInfoForm.formData.zip){
            Message.error(t('customer.zip') + ' ' + t('base.noEmpty'))
            return false
        }else if(!editAddressInfoForm.formData.country){
            Message.error(t('customer.customerCountry') + ' ' + t('base.noEmpty'))
            return false
        }else if(!editAddressInfoForm.formData.city){
            Message.error(t('customer.customerCity') + ' ' + t('base.noEmpty'))
            return false
        }else if(!editAddressInfoForm.formData.street){
            Message.error(t('dealer.street') + ' ' + t('base.noEmpty'))
            return false
        }else if(!editAddressInfoForm.formData.address){
            Message.error(t('customer.customerAddr') + ' ' + t('base.noEmpty'))
            return false
        }else if(!editAddressInfoForm.formData.house_number){
            Message.error(t('dealer.houseNumber') + ' ' + t('base.noEmpty'))
            return false
        }

        let param = {
           ...editAddressInfoForm.formData,
           first_flag: editAddressInfoForm.formData.first_flag? 1 : 0,
           type: rowData.value.type_val,
           source: rowData.value.source_val,
           erp_code: rowData.value.erp_code,
           customer_entity_id:rowData.value.customer_entity_id,
           id:rowData.value.id,
        }
        table.value.configs.loading = true
        let res = await CustomerApi.getInstance().editAddress(param,rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.editSuccess'))
            if(route && route.query.fromPage){
                table.value.configs.loading = false
                router.replace(`/${route.query.fromPage}`)
            }else{
                // getCustomerHead()
                // customerTableRef.value.expandedKeys = []
                expandRow(rowHeadData.value.id, rowHeadData.value)
                table.value.configs.loading = false
            }
            return true
        }else{
            Message.error(res.msg)
        }
    }

    // 编辑经销商子级ERP Code
    const onEditERPCodeBeforeOk = async ()=>{
        let reg = /^ODE[0-9]{4}-[A-Z0-9]{3,4}$/
        if(!erp_sub_code.value){
            Message.error(t('customer.dealerErpCode')+ ' ' +t('base.noEmpty'))
            return false
        }else if(!reg.test(erp_sub_code.value.trim())){
            Message.error(t('customer.subErpCodeTip'))
            return false
        }

        let param = {
            id: rowData.value.id,
            erp_sub_code:erp_sub_code.value.trim(),
        }
        let res = await CustomerApi.getInstance().saveSubERPCode(param)
        if(res.code == 0){
            Message.success(t('base.editSuccess'))
            // getCustomerHead()
            // customerTableRef.value.expandedKeys = []
            expandRow(rowHeadData.value.id, rowHeadData.value)
            table.value.configs.loading = false
            return true
        }else{
            Message.error(res.msg)
            return false
        }
    }

    // 删除客户地址
    const deleteAddress = async(row)=>{
        let res = await CustomerApi.getInstance().deleteAddress(row.id)
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            // getCustomerHead()
            // customerTableRef.value.expandedKeys = []
            expandRow(rowHeadData.value.id, rowHeadData.value)
            table.value.configs.loading = false
        }else{
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                content: res.msg,
                okText:t('base.ok'),
            });
        }
    }

    // 删除子级ERP Code
    const deleteSubERPCode = async(row)=>{
        let res = await CustomerApi.getInstance().deleteSubERPCode(row.id)
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            // getCustomerHead()
            // customerTableRef.value.expandedKeys = []
            expandRow(rowHeadData.value.id, rowHeadData.value)
            table.value.configs.loading = false
        }else{
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                content: res.msg,
                okText:t('base.ok'),
            });
        }
    }

    // 编辑location
    const editLocation = async (row)=>{
        if(!row.location_name){
            Message.error(t('customer.locationName')+ ' ' +t('base.noEmpty'))
            return false
        }else if(!row.shipping_address_id){
            Message.error(t('customer.shippingAddress')+ ' ' +t('base.noEmpty'))
            return false
        }else if(!row.invoice_address_id){
            Message.error(t('customer.invoiceAddress')+ ' ' +t('base.noEmpty'))
            return false
        }else if(!row.base_address_id){
            Message.error(t('customer.baseAddress')+ ' ' +t('base.noEmpty'))
            return false
        }else if(!row.customer_email){
            Message.error(t('customer.customerEmail')+ ' ' +t('base.noEmpty')+ ' '+t('customer.firstNameTip'))
            return false
        }else if(!row.first_name){
            Message.error(t('customer.firstName')+ ' ' +t('base.noEmpty')+ ' '+t('customer.firstNameTip'))
            return false
        }else if(!row.last_name){
            Message.error(t('customer.lastName')+ ' ' +t('base.noEmpty'))
            return false
        }

        let param = {
            location_name:row.location_name,       
            customer_email:row.customer_email,
            first_name:row.first_name,
            last_name:row.last_name,
            shipping_address_id:row.shipping_address_id,
            invoice_address_id:row.invoice_address_id,
            base_address_id:row.base_address_id,
        }
        if(row.type == 'add'){
            param.erp_code = rowData.value.erp_code
        }else if(row.type == 'edit'){
            param.id = row.id
            param.erp_code = row.erp_code
        } 

        locationTable.value.configs.loading = true
        let res = await CustomerApi.getInstance().saveLocation(param)
        if(res.code == 0){
            row.isEdit = false
            row.disabled = !row.disabled
            locationTable.value.configs.loading = false
            getLocationList(rowData.value)
            Message.success(t('base.editSuccess'))
        }else if(res.code == 1047){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                content: res.msg,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{
                    locationTable.value.configs.loading = false
                }
            });
        }else{
            Message.error(res.msg)
            locationTable.value.configs.loading = false
        }
    }

    // 获取location列表
    const getLocationList = async (row)=>{
        let param = {
           erp_code: row.erp_code
        }
        locationTable.value.configs.loading = true
        let res = await CustomerApi.getInstance().getLocationList(param)
        if(res.code == 0){
            locationTable.value.configs.loading = false
            locationTable.value.datas = []
            res.data.length > 0 && res.data.forEach((item,index)=>{
                locationTable.value.datas.push({
                    ...item,
                    serial: index + 1,
                    disabled: true,
                    isEdit:false,
                    type:'edit'
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    const invalidPickUpLocationEdit = async (row)=>{
        let res = await CustomerApi.getInstance().invalidPickUpLocation(row.id)
        if(res.code == 0){
            Message.success(t('base.invalidSucess'))
            getPickUpLocationList(rowData.value)
        }else{
            Message.error(res.msg)
        }
    }

    const editPickUpLocation = async (row)=>{
        if(!row.point_name){
            Message.error(t('customer.pickUplocationName')+'' +t('base.noEmpty'))
            return false
        }else if(!row.address_id){
            Message.error(t('customer.pickUpAddress')+'' +t('base.noEmpty'))
            return false
        }else if(!row.country){
            Message.error(t('customer.country')+'' +t('base.noEmpty'))
            return false
        }else if(!row.city){
            Message.error(t('customer.city')+'' +t('base.noEmpty'))
            return false
        }else if(!row.address){
            Message.error(t('customer.address')+'' +t('base.noEmpty'))
            return false
        }

        let param = {
            point_name:row.point_name,
            address_id:row.address_id,
            enable_flag:row.enable_flag,
        }

        if(row.type == 'add'){
            param.erp_code = rowData.value.erp_code
        }else if(row.type == 'edit'){
            param.id = row.id
            param.erp_code = row.erp_code
        }

        pickUpLocationTable.value.configs.loading = true
        let res = await CustomerApi.getInstance().savePickUpLocation(param)
        if(res.code == 0){
            row.isEdit = false
            row.disabled =!row.disabled
            pickUpLocationTable.value.configs.loading = false
            getPickUpLocationListData(rowData.value)
            Message.success(t('base.editSuccess'))
        }else if(res.code == 1047){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                content: res.msg,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{
                    pickUpLocationTable.value.configs.loading = false
                }
            })
        }
    }

     // 获取pick up列表
     const getPickUpLocationListData = async (row)=>{
        let param = {
           erp_code: row.erp_code
        }
        locationTable.value.configs.loading = true
        let res = await CustomerApi.getInstance().getPickUpLocationList(param)
        if(res.code == 0){
            pickUpLocationTable.value.configs.loading = false
            pickUpLocationTable.value.datas = []
            res.data.length > 0 && res.data.forEach((item,index)=>{
                item.country = item.customer_info.country
                item.city = item.customer_info.city
                item.address = item.customer_info.address
                item.zip = item.customer_info.zip
                item.phone = item.customer_info.phone
                item.email = item.customer_info.customer_email

                pickUpLocationTable.value.datas.push({
                    ...item,
                    serial: index + 1,
                    disabled: true,
                    isEdit:false,
                    type:'edit'
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    const changeSelectPickUpLocationAddress = (val, row)=>{
        let pick_up_address = pickUpOptions.value.find(i=> i.value == val)
        row.country = pick_up_address.item.country
        row.city = pick_up_address.item.city
        row.address = pick_up_address.item.address
        row.zip = pick_up_address.item.zip
        row.phone = pick_up_address.item.phone
        row.email = pick_up_address.item.email
    }

    // 基础地址选择
    const changeSelectLocationAddress = (val, key, row)=>{
        console.log(val,key,row,'key')
        if(key == 'shipping_address_id'){
            // row.baseOptions = []
            row.base_address_id = ''
            // let ship_address = shipOptions.value.find(i=> i.value == val)
            // row.baseOptions.push({
            //     label: ship_address.label,
            //     value: ship_address.value,
            //     item: ship_address.item,
            // })

            if(row.invoice_address_id !== ''){
                let ship_address = shipOptions.value.find(i=> i.value == val)
                let invoice_address = invoiceOptions.value.find(i=> i.value == row.invoice_address_id)
                if(ship_address.label == invoice_address.label){
                    row.base_address_id = row.shipping_address_id
                    changeSelectLocationAddress(row.shipping_address_id, 'base_address_id', row)
                }
            }
        }
        if(key == 'invoice_address_id'){
            // row.baseOptions = []
            row.base_address_id = ''
            // let invoice_address = invoiceOptions.value.find(i=> i.value == val)
            // row.baseOptions.push({
            //     label: invoice_address.label,
            //     value: invoice_address.value,
            //     item: invoice_address.item,
            // })

            if(row.shipping_address_id !== ''){
                let ship_address = shipOptions.value.find(i=> i.value == row.shipping_address_id)
                let invoice_address = invoiceOptions.value.find(i=> i.value == val)
                if(ship_address.label == invoice_address.label){
                    row.base_address_id = row.shipping_address_id
                    changeSelectLocationAddress(row.shipping_address_id, 'base_address_id', row)
                }
            }
        }
        if(key == 'base_address_id'){
            let opt = baseOptions.value.find(i=> i.value == val)

            row.customer_email = opt.item.email
            let name2_arr = opt.item.name2? opt.item.name2.trim().split(' ') : []
            let last_name = name2_arr.length > 0? name2_arr[name2_arr.length - 1] : ''
            let first_name = last_name == ''? '' : opt.item.name2.split(last_name)[0].trim()

            row.first_name = first_name
            row.last_name = last_name
        }
    }

    // 保存查阅客户详细信息记录
    const sensitive = async (row)=>{
        let param = {
            code: "customer",
            data: row
        }
        let res = await CustomerApi.getInstance().sensitive(param)
        if(res.code == 0){
           
        }else{
            Message.error(res.msg)
        }
    }

    // 获取国家下拉配置
    const getCountry = async ()=>{
        let res = await CustomerApi.getInstance().getCountry({enable_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'country')
            let addItem = addBaseInfoForm.formField.find(i=> i.key == 'country')
            let addItem2 = addAddressInfoForm.formField.find(i=> i.key == 'country')
            let addItem3 = addInvoiceAddressForm.formField.find(i=> i.key == 'country')
            let editItem = editBaseInfoForm.formField.find(i=> i.key == 'country')
            let editItem2 = editAddressInfoForm.formField.find(i=> i.key == 'country')
            
            item.options = []
            addItem.options = []
            addItem2.options = []
            addItem3.options= []
            editItem.options = []
            editItem2.options = []

            res.data.forEach(i=>{
                item.options.push({
                    label:i.country,
                    value:i.country
                })
                addItem.options.push({
                    label:i.country,
                    value:i.country,
                    code:i.country_code, // 国家编码
                })
                addItem2.options.push({
                    label:i.country,
                    value:i.country,
                    code:i.country_code, // 国家编码
                })
                addItem3.options.push({
                    label:i.country,
                    value:i.country,
                    code:i.country_code, // 国家编码
                })
                editItem.options.push({
                    label:i.country,
                    value:i.country,
                    code:i.country_code, // 国家编码
                })
                editItem2.options.push({
                    label:i.country,
                    value:i.country,
                    code:i.country_code, // 国家编码
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型 和 erp客户编码
    const getOrderSource = async ()=>{
        let res = await CustomerApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            let queryItem = queryForm.formField.find(i=> i.key == 'source')
            let addItem = addBaseInfoForm.formField.find(i=> i.key == 'source')
            let editBaseItem = editBaseInfoForm.formField.find(i=> i.key == 'source')
            queryItem.options = []
            addItem.options = []
            editBaseItem.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                if(i.type != 1){
                    addItem.options.push({
                        label: i.id == '1'? 'Shopify' : i.customer_name,
                        value:i.id, // 来源类型
                        code: i.customer_number, // erp客户编码
                        type: i.type, // 客户类型
                        disabled: i.type == 1
                    })
                }

                queryItem.options.push({
                    label: i.id == '1'? 'Shopify' : i.customer_name,
                    value:i.id, // 来源类型
                    code: i.customer_number, // erp客户编码
                })

                editBaseItem.options.push({
                    label: i.id == '1'? 'Shopify' : i.customer_name,
                    value:i.id, // 来源类型
                    code: i.customer_number, // erp客户编码
                    type: i.type, // 客户类型
                    disabled: i.type == 1
                })

                sourceList[i.id] = i.id == '1'? 'Shopify' : i.customer_name
            }) 
        }else{
            Message.error(res.msg)
        }
    }

    // 获取客户名称
    const getCustomerName = async ()=>{
        let res = await StockOutApi.getInstance().getCustomerList({simple_flag:1})
        if(res.code == 0){
            const item = queryForm.formField.find(i=> i.key == 'name')
            item.options= []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.name,
                    value: i.name, 
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取默认地址
    const getDefaultAddress = async ()=>{
        let param = {
            dict_code: "config",
            dict_sub_code: "factory_default",
            dict_sub_name: "address",
        }
        let res = await CustomerApi.getInstance().getDefaultAddress(param)
        if(res.code == 0){
            return res.data[0].dict_sub_value
        }else{
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 30
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 100
    }


    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(()=>{
        init()
        getOrderSource()
        getCustomerHead()   
        getCountry()
        getCustomerName()
        getDefaultAddress()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })

</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:6;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
            margin-right:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        // flex-direction: column;
        // flex-wrap:wrap;
        flex: 1;
        align-items: center;
        justify-content: center;
        border-left:1px solid #eee;
        padding-left:10px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:90px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table .arco-table-cell{
    padding: 9px 10px;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 10px 0;
    font-size: 12px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 10px 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
    font-size: 12px;
}

/deep/.childrenTable{
    .arco-table-th{
        background-color: #000 !important;
        color: #fff;
        border-bottom: 1px solid #eee;
        padding: 0;
        font-weight: 300;
        font-size:12px;
    }
    .arco-table-td{
        padding: 0;
        background-color: #ddd !important;
    }

    .arco-icon-filter{
        color: #fff;
    }
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

.editForm{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-select,
    /deep/ .arco-picker-size-medium{
        height: 45px;
    }

    /deep/ .arco-form-item-label-col{
        line-height: 45px;
    }
}

.operateBtn{
    margin:0 2px;
}

.delete{
    color: red;
    cursor: pointer;
}

/deep/ .arco-switch{
    margin-top: 13px;
}

/deep/ .arco-radio-group{
    margin-top: 12px;
}

.locationTable{
    /deep/ .arco-pagination{
        display: none;
    }

    /deep/ .arco-table-td{
        padding:0;
    }
}

.countBar{
    margin-top: 10px;
    font-size:12px;
    font-weight: 600;

    span{
        display:inline-block;
        margin-right: 20px;
    }
}

/deep/ .arco-alert{
    padding: 1px 15px;
    vertical-align: bottom;

    .arco-alert-icon,
    .arco-alert-body{
        display: inline-block !important;
    }
}

/deep/ .arco-modal-body{
    text-align: center;
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

/deep/ .arco-table-filters svg{
    color:#fff;
}

/deep/ .arco-btn-size-mini{
    padding: 0 5px;
}

</style>